<template>
  <tbody class="is-editable">
    <tr>
      <td class="c-table__cell--center c-table__cell--middle u-w160">
        {{ topicCondition.topic_condition_id }}
      </td>
      <td class="c-table__cell--left c-table__cell--middle u-w290">
        <p class="u-w258 u-text-ellipsis">{{ topicCondition.condition_name }}</p>
      </td>
      <td class="c-table__cell--left c-table__cell--middle">
        <p v-for="(topicConditionDetail, loopIndex1) in topicCondition.topic_condition_details" :key="loopIndex1">{{ getTopicConditionDetailTypeString(topicConditionDetail) }} / {{ getTopicConditionDetailValueString(topicConditionDetail) }} </p>
        <div class="c-table-editable">
          <ul class="c-table-editable-list">
            <li class="c-table-editable-list__item">
              <a class="c-btn c-btn--gray-3 c-btn--circle" href="#trash" @click="onEditClick">
                <div class="c-btn__text c-btn__text--balloon">編集する</div>
                <div class="c-icon c-icon--gray-3 u-wh20">
                  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <use xlink:href="/assets/img/sprite.svg#edit" />
                  </svg>
                </div>
              </a>
            </li>
            <li class="c-table-editable-list__item">
              <a class="c-btn c-btn--gray-3 c-btn--circle" href="#trash" @click="onCopyClick">
                <div class="c-btn__text c-btn__text--balloon">複製する</div>
                <div class="c-icon c-icon--gray-3 u-wh20">
                  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <use xlink:href="/assets/img/sprite.svg#clone" />
                  </svg>
                </div>
              </a>
            </li>
            <li class="c-table-editable-list__item">
              <a class="c-btn c-btn--gray-3 c-btn--circle" href="#trash" @click="onDeleteClick">
                <div class="c-btn__text c-btn__text--balloon">削除する</div>
                <div class="c-icon c-icon--gray-3 u-wh20">
                  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <use xlink:href="/assets/img/sprite.svg#trash" />
                  </svg>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
export default {
  props: {
    topicCondition: Object,
    conditionInfo: Object,
  },
  emits: ["delete-click","copy-click","edit-click"],
  methods: {
    onDeleteClick: function () {
      this.$emit('delete-click',this.topicCondition.topic_condition_id);
    },
    onCopyClick: function () {
      this.$emit('copy-click',this.topicCondition.topic_condition_id);
    },
    onEditClick: function () {
      this.$emit('edit-click',this.topicCondition.topic_condition_id);
    },
  },

};
</script>
